import { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { useNavigate } from "react-router-dom";
import Button from "../Button";

interface Props {
  park: any;
}

const ParksCard = ({ park }: Props) => {
  const navigate = useNavigate();

  return (
    <StyledParksCard>
      <ParkLogo src={park.logo} />
      <span>{park.name}</span>
      <Button
        onClick={() => navigate(`/admin/manage-parks/${park?._id}`)}
        label="View Products"
        color={Colors.aqua}
        fontColor={Colors.white}
        outlineColor={Colors.aqua}
      />
      <Button
        onClick={() => navigate(`/admin/edit-park/${park?._id}`)}
        label="Edit Park"
        color={Colors.white}
        fontColor={Colors.aqua}
        outlineColor={Colors.aqua}
      />
    </StyledParksCard>
  );
};

const StyledParksCard = styled.div`
  border: 2px solid ${Colors.cloudyGrey}3A;
  border-radius: 2rem;
  width: 70%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 0.5rem;
  > span {
    padding: 0.5rem 0;
  }
  @media only screen and (max-width: 768px) {
    width: 80%;
    // height: 15rem;
  }
  @media only screen and (max-width: 526px) {
    width: 80%;
    // height: 18rem;
  }
`;

const ParkLogo = styled.img`
  width: 65%;
`;

export default ParksCard;
